import Message from '../../../../components/message';
import returnsNotificationUp from './returns-notification-up';

export default returnsNotificationUp(Message);
